import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

// MapLibre v6 + Vite: wire the worker through Vite's worker pipeline.
setWorkerUrl(workerUrl);
